<template>
  <div>
    <div class="mx-2">
      <v-switch dense v-model="groupBy" :label="groupByLabel"></v-switch>
    </div>
    <div>
      <v-expansion-panels accordion v-if="(!!model) && !groupBy" v-model="localPanelIndex">
        <v-expansion-panel v-for="(point, index) in model.pointsGroups" v-bind:key="index">
          <v-expansion-panel-header>{{ point.latitude }} {{ point.longitude }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs background-color="red lighten-2" dark show-arrows>
              <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
              <v-tab v-for="item in model.parameters" v-bind:key="item.sname">{{ item.sname }}</v-tab>

              <v-tab-item v-for="item in point.parameterGroups" v-bind:key="item.code">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Дата</th>
                        <th>Значение</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in item.values" v-bind:key="data.code">
                        <td>{{ data.code }}</td>
                        <td>{{ data.value }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs>
            <div>
              <reanalysis-chart :model="point" :parameters="model.parameters" />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels accordion v-if="(!!model) && groupBy">
        <v-expansion-panel v-for="(point, index) in model.pointsGroups" v-bind:key="index">
          <v-expansion-panel-header>{{ point.latitude }} {{ point.longitude }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs background-color="red lighten-2" dark show-arrows>
              <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
              <v-tab v-for="(item, index) in reftimes" v-bind:key="item.refTime">
                <base-time-title v-model="reftimes[index]" />
              </v-tab>

              <v-tab-item v-for="item in point.refTimeGroups" v-bind:key="item.refTime">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Параметр</th>
                        <th>Значение</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in item.values" v-bind:key="data.code">
                        <td>{{ data.code }}</td>
                        <td>{{ data.value }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs>
            <div>
              <reanalysis-chart :model="point" :parameters="model.parameters" />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import BaseTimeTitle from "../views/components/BaseTimeTitle.vue";
import ReanalysisChart from "./ReanalysisChart.vue";
import formatReftime from "./format/formatReftime.js";
import RefTimeViewModel from "../components/viewmodels/RefTimeViewModel.js";

export default {
  name: "ReanalysisTabs",
  components: {
    ReanalysisChart,
    BaseTimeTitle
  },
  props: {
    model: Object,
    value: Number
  },
  data: function() {
    return {
      groupBy: false,
      predicts: [],
      reftimes: []
    };
  },
  computed: {
    groupByLabel() {
      if (this.groupBy) return "Сгруппировать по датам";
      return "Сгруппировать по параметрам";
    },
    localPanelIndex: {
      get() {
        return this.value;
      },
      set(localPanelIndex) {
        this.$emit("input", localPanelIndex);
      }
    }
  },
  watch: {
    model: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const reftimes = newVal.reftimes.map(x => new Date(x));
          const maxDate = Math.max(...reftimes);
          const start = new Date(maxDate);
          this.reftimes = reftimes.map(x => {
            const result = new RefTimeViewModel();
            result.refTime = x;
            const labels = formatReftime(x, start);
            result.title = labels[0];
            result.subTitle = labels[1];
            return result;
          });
        }
      }
    }
  }
};
</script>